import script from "./footerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./footerComponent.vue?vue&type=script&setup=true&lang=js"

import "./footerComponent.vue?vue&type=style&index=0&id=9ef04cec&class=less&lang=css"
import "./footerComponent.vue?vue&type=style&index=1&id=9ef04cec&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ef04cec"]])

export default __exports__